import { render, staticRenderFns } from "./brandDialog.vue?vue&type=template&id=9ca69ebe&scoped=true"
import script from "./brandDialog.vue?vue&type=script&lang=js"
export * from "./brandDialog.vue?vue&type=script&lang=js"
import style0 from "./brandDialog.vue?vue&type=style&index=0&id=9ca69ebe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../../../opt/build-cache/ad/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ca69ebe",
  null
  
)

export default component.exports